enum OperationType {
  AND = 'and',
  OR = 'or',
}

export default OperationType;
